import { apiClient } from '../../../shared/services/apiClient';
import { EnquiryFormData } from '../validation/enquirySchemas';
import { IAssignee, IEnquiry, EnquiryStats } from '../types/enquiry.types';

interface ListEnquiriesResponse {
    items: IEnquiry[];
    stats: EnquiryStats;
    total: number;
    page: number;
    totalPages: number;
}

export const enquiryService = {
    submit: (data: EnquiryFormData) =>
        apiClient.post<{ referenceId: string; message: string }>('/enquiries', data),

    fetchAll: (page: number, limit: number, status?: string, sortBy = 'createdAt', sortOrder: 'asc' | 'desc' = 'desc') =>
        apiClient.get<ListEnquiriesResponse>('/enquiries', {
            params: { page, limit, sortBy, sortOrder, ...(status && status !== 'all' ? { status } : {}) },
        }),

    updateStatus: (id: string, status: string) =>
        apiClient.patch(`/enquiries/${id}/status`, { status }),

    update: (id: string, updates: { status?: string; category?: string }) =>
        apiClient.patch<IEnquiry>(`/enquiries/${id}`, updates),

    deleteEnquiry: (id: string) =>
        apiClient.delete<{ message: string }>(`/enquiries/${id}`),

    fetchMyTickets: (page: number, limit: number, status?: string) =>
        apiClient.get<ListEnquiriesResponse>('/enquiries/my-tickets', {
            params: { page, limit, ...(status && status !== 'all' ? { status } : {}) },
        }),

    fetchAssignees: () =>
        apiClient.get<IAssignee[]>('/enquiries/assignees'),

    assign: (id: string, assigneeId: string) =>
        apiClient.patch<IEnquiry>(`/enquiries/${id}/assign`, { assigneeId }),

    unassign: (id: string) =>
        apiClient.patch<IEnquiry>(`/enquiries/${id}/unassign`),

    fetchById: (id: string) =>
        apiClient.get<IEnquiry>(`/enquiries/${id}`),

    addReply: (id: string, message: string) =>
        apiClient.post<IEnquiry>(`/enquiries/${id}/replies`, { message }),
};
